import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';

import { ErrorComponent } from './error.component';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
    imports: [
        SharedModule,
        // Routing
        RouterModule.forChild([
            {
                path: 'error',
                component: ErrorComponent,
            },
        ]),
        MatButtonModule,
    ],
    declarations: [ErrorComponent],
    exports: [
        ErrorComponent
    ]
})
export class ErrorModule
{
}
